import { userTypes } from '@/constants';
import type { SessionUser, User } from '@/types/user';

const rolesByType: Record<number, string> = userTypes;

/**
 * Собирает пользователя стора из прежних данных и ответа бэка
 *
 * @param prev - текущий пользователь в сторе
 * @param data - пользователь из ответа `session` / `login`
 */
export const buildUser = (prev: User, data: SessionUser): User => {
    // Пустые поля из ответа не затирают значения по умолчанию
    const filled = Object.fromEntries(Object.entries(data).filter(([, value]) => value != null));

    return {
        ...prev,
        ...filled,
        isAuthorized: true,
        userRole:     rolesByType[data.userType] ?? '',
    };
};
